import { ConfigProvider, theme, App, notification } from "antd";
import enUS from "antd/locale/en_US";
import { BrowserRouter } from "react-router-dom";
import { useTheme } from "./store/context/theme-context";
import { getSubdomain } from "./utils/routes/baseURLRetriver"; // Adjust the path as necessary
import { OtpProvider } from "./store/context/otp-context";
import AppRoutes from "./shared/routes/AppRoutes";
import { FormDataProvider } from "./store/context/form-data-context";
import { NotificationProvider } from "./store/context/notification-context";
import { WebSocketProvider } from "./shared/utils/signalr";
import { DashboardProvider } from "./store/context/DashboardContext";
import SignalRNavigationHelper from "./shared/utils/SignalRNavigationHelper";
import { OrganisationProvider } from "./store/context/admin/organisation-context";
import { UserProvider } from "./store/context/admin/user-context";
import { ApiProvider } from "./utils/api/https/executor";
import { FeatureProvider } from "./store/context/feature-context";
import { TenantProvider } from "./store/context/tenant-context";
import { getTenant } from "./shared/config/tenantConfiguration";
import MandateProvider from "./store/context/admin/mandate-context";
import { TransferProvider } from "./store/context/admin/transfer-context";
import { useEffect } from "react";
import { ProductConfigurationProvider } from "./store/context/admin/product-configuration-context";
import { MenuProvider } from "./store/context/admin/menu-context";
import { UserPreferenceProvider } from "./store/context/user-preference-context";
import { DashboardLayoutProvider } from "./store/context/dashboard-layout-context";
import AuthExpiredHandler from "./utils/api/requests/AuthExpiredHandler";
import { WorkflowProvider } from "./store/context/admin/workflow-context";
import InactivityModal from "./components/InactivityModal/InactivityModal";
import AgentCopilotWidget from "./components/Agent/AgentCopilotWidget";

const MyApp = () => {
  const { theme: selectedTheme } = useTheme();

  const lightTheme = selectedTheme === "light";
  const tenant = getTenant();
  document.title = tenant.title;

  useEffect(() => {
    const link =
      document.querySelector("link[rel~='icon']") ||
      document.createElement("link");
    link.rel = "icon";
    link.href = tenant.logo;
    if (!link.parentNode) {
      document.head.appendChild(link);
    }
  }, []);

  return (
    <ConfigProvider
      locale={enUS}
      theme={{
        token: {
          colorPrimary: tenant.theme.colorPrimary,
        },
        components: {
          Message: {
            zIndexPopup: 9999,
          },
        },
        algorithm: lightTheme ? theme.defaultAlgorithm : tenant.theme.algorithm,
      }}
    // modal={{
    //   okText: "OK",
    //   cancelText: "Cancel",
    // }}
    >
      <App>
        <TenantProvider tenant={tenant}>
          <ApiProvider>
            <NotificationProvider>
              <FormDataProvider>
                <OtpProvider>
                  <BrowserRouter>
                    <SignalRNavigationHelper />
                    <AuthExpiredHandler />
                    <InactivityModal />
                    <DashboardProvider>
                      <WebSocketProvider>
                        <TransferProvider>
                          <OrganisationProvider>
                            <ProductConfigurationProvider>
                              <UserProvider>
                                <MandateProvider>
                                  <MenuProvider>
                                    <WorkflowProvider>
                                      <UserPreferenceProvider
                                        initialPreferences={{}}>
                                        <DashboardLayoutProvider>
                                          <AppRoutes />
                                          <AgentCopilotWidget />
                                        </DashboardLayoutProvider>
                                      </UserPreferenceProvider>
                                    </WorkflowProvider>
                                  </MenuProvider>
                                </MandateProvider>
                              </UserProvider>
                            </ProductConfigurationProvider>
                          </OrganisationProvider>
                        </TransferProvider>
                      </WebSocketProvider>
                    </DashboardProvider>
                  </BrowserRouter>
                </OtpProvider>
              </FormDataProvider>
            </NotificationProvider>
          </ApiProvider>
        </TenantProvider>
      </App>
    </ConfigProvider>
  );
};

export default MyApp;
